<div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; height: 100%">
    <iframe *ngIf="loadInSandbox && url$ | async as url; else originalFrame"
            [src]="url | safeResourceUrl"
            [ngClass]="{'disable-mouse-events' : isContextPanelResizing}"
            style="background-color: white;"
            sandbox="allow-"></iframe>
  <ng-template #originalFrame>
      <iframe *ngIf="url$ | async as url"
            [src]="url | safeResourceUrl"
            [ngClass]="{'disable-mouse-events' : isContextPanelResizing}"
            style="background-color: white;"></iframe>
  </ng-template>

</div>


